import { useDynamicConfig } from "@statsig/react-bindings";

export const useUnreadChatChannelCountRefetchInterval = () => {
  return useDynamicConfig("chat_polling_rates").get(
    // This is named UNREAD_CONVERSATION_COUNT despite us using
    // chat channel as the name... this is preserved for
    // backwards compatibility with the dynamic config
    // values.
    "UNREAD_CONVERSATION_COUNT",
    10000,
  );
};

export const useNewMessagesRefetchInterval = () => {
  return useDynamicConfig("chat_polling_rates").get("NEW_MESSAGES", 5000);
};

export const useNewChatChannelsRefetchInterval = () => {
  // This is named NEW_CONVERSATIONS despite us using
  // chat channel as the name... this is preserved for
  // backwards compatibility with the dynamic config
  // values.
  return useDynamicConfig("chat_polling_rates").get("NEW_CONVERSATIONS", 10000);
};
